export enum SlatAssessmentStatus {
  Completed = 0,
  UnableToComplete = 1,
  UnsuitableForStandardAssessment = 2,
}
